import { focusContenteditableDiv } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { getFaqAutocompleteStatements } from './faqAutocomplete.api';
import { FaqAutocompleteTemplate } from './faqAutocomplete.template';

export class FaqAutocomplete {
	constructor(props) {
		this.init(props);
	}

	init(props) {
		this.initData(props);
		this.initWrapper();
		this.initEvents();
		this.initHelpers();
	}

	initData(props) {
		this.data = {
			faqAutocompleteOptionsData: props || [],
		};
		this.setter(props);
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.id = 'engtFaqAutocompleteWrapper';
		wrapper.className = 'engt-faq-autocomplete-wrapper engt-faq-autocomplete-wrapper-animate';
		wrapper.setAttribute('tabindex', '2');
		wrapper.innerHTML = FaqAutocompleteTemplate(this.data);

		this.html = wrapper;
	}

	initEvents() {
		const ref = this;
		const listItems = this.html.querySelectorAll('li');
		for (let i = 0; i < listItems.length; i++) {
			listItems[i].addEventListener('click', function () {
				ref.triggerFaqAutocompleteOption(this.innerText);
			});
		}
	}

	initHelpers() {
		ENGT_CHAT.set('reRenderFaqAutoComplete', this.reRenderFaqAutoComplete.bind(this));
	}

	initComponents() {
		if (!this.onBtn || !this.offBtn) {
			this.onBtn = document.querySelector('#engtFaqAutocompleteBtnOn');
			this.offBtn = document.querySelector('#engtFaqAutocompleteBtnOff');
		}
	}

	triggerFaqAutocompleteOption(option) {
		const container = document.getElementById('engtUserMessage');
		container.innerHTML = option;
		focusContenteditableDiv();
		this.closeFaqAutocompletePopUp();
	}

	closeFaqAutocompletePopUp() {
		const ref = this;
		const faqAutocompleteWrapper = document.querySelector('#engtFaqAutocompleteWrapper');
		if (faqAutocompleteWrapper) {
			faqAutocompleteWrapper.style.display = 'none';
		}
		ref.changeBtnToUpArrow.call(ref);
	}

	changeBtnToDownArrow() {
		if (this.onBtn && this.offBtn) {
			this.onBtn.classList.remove('engt-hidden');
			this.offBtn.classList.add('engt-hidden');
		}
	}

	changeBtnToUpArrow() {
		const faqAutocompleteWrapper = document.querySelector('#engtFaqAutocompleteWrapper');
		if (this.offBtn && this.onBtn && faqAutocompleteWrapper?.innerHTML) {
			this.offBtn.classList.remove('engt-hidden');
			this.onBtn.classList.add('engt-hidden');
		}
	}

	hideArrowBtns() {
		if (this.offBtn) this.offBtn.classList.add('engt-hidden');
		if (this.onBtn) this.onBtn.classList.add('engt-hidden');
	}

	openFaqAutocompletePopUp() {
		const ref = this;
		const faqAutocompleteWrapper = document.querySelector('#engtFaqAutocompleteWrapper');
		if (faqAutocompleteWrapper) {
			faqAutocompleteWrapper.style.display = 'flex';
		}
		ref.changeBtnToDownArrow();
	}

	fetchAutocompleteResults(input, indexUid) {
		const ref = this;
		getFaqAutocompleteStatements(ref, indexUid, input, document);
	}

	pushStatementToPopUp = (respObj) => {
		const statements = respObj.hits?.map((hit) => hit.statement);
		return statements;
	};

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	reRenderFaqAutoComplete(data) {
		this.init(data);
		const wrapper = document.getElementById('engtFaqAutocompleteWrapper');
		if (wrapper) {
			wrapper.parentNode.replaceChild(this.html, wrapper);
		} else {
			document.getElementById('engtChatWrapper').appendChild(this.html);
		}
	}

	render() {
		return this.html;
	}
}
